import { render } from "./myRegistration.vue?vue&type=template&id=20fef8bf&scoped=true"
import script from "./myRegistration.vue?vue&type=script&lang=js"
export * from "./myRegistration.vue?vue&type=script&lang=js"

import "./myRegistration.vue?vue&type=style&index=0&id=20fef8bf&lang=scss"
import "./myRegistration.vue?vue&type=style&index=1&id=20fef8bf&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20fef8bf"]])

export default __exports__